import { render, staticRenderFns } from "./SystemError.vue?vue&type=template&id=3edb2f40&scoped=true&lang=pug"
import script from "./SystemError.vue?vue&type=script&lang=js"
export * from "./SystemError.vue?vue&type=script&lang=js"
import style0 from "./SystemError.vue?vue&type=style&index=0&id=3edb2f40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edb2f40",
  null
  
)

export default component.exports